export interface FeedResponseProps {
  category: string
  description: string
  unit: string
  quantity: number
  unitValue: number
  totalValue: number
}

export const feedMock: FeedResponseProps[] = [
  {
    category: 'Carne',
    description: 'Assinha de Frango',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Bife Bovino',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Bacon Fatiado',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Bife Coxa e Sobrecox...',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Carne Moída AM',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Cubos Suíno',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Cupim',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Denver Steak',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Entranha de boi',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  },
  {
    category: 'Carne',
    description: 'Fraldinha',
    unit: '60kg',
    quantity: 500,
    unitValue: 28.7,
    totalValue: 14350
  }
]
